import { render, staticRenderFns } from "./Counselors.vue?vue&type=template&id=e54a1bf6"
import script from "./Counselors.vue?vue&type=script&lang=js"
export * from "./Counselors.vue?vue&type=script&lang=js"
import style0 from "./Counselors.vue?vue&type=style&index=0&id=e54a1bf6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports